import { CmsApplianceDetailsForm } from '../appliance-details/cms-appliance-details-form.interface';
import { CmsRegistrationRoot } from '../cms/cms-registration-root.interface';
import { CmsHighlightedPartners } from './cms-highlighted-partners.interface';

export interface CmsExtraApplianceDetailsPage
  extends CmsRegistrationRoot,
    CmsApplianceDetailsForm,
    CmsHighlightedPartners {
  pageTitle: string;
}
